import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=0a0c08f0&scoped=true&"
import script from "./Main.vue?vue&type=script&charset=utf-8&lang=js&"
export * from "./Main.vue?vue&type=script&charset=utf-8&lang=js&"
import style0 from "./Main.vue?vue&type=style&index=0&id=0a0c08f0&lang=scss&rel=stylesheet%2Fsass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0c08f0",
  null
  
)

export default component.exports